import React from "react";
import "../About/About.css";
import { Link } from "react-router-dom";

const About = () => {
  return (
    <section className="about-section-a">
      <div className="about-left-a">
        <p className="faded-text-a">OUR STORY</p>
        <hr className="divider-a" />
        <p className="expertise-a">DECADES OF DEDICATION</p>
        <h1 className="heading-a">Story About Lawyer Firm</h1>
        <p className="description-a">
          At Lawyer Firm, we understand that navigating the intricate landscape
          of legal challenges can be daunting. Our seasoned team of dedicated
          legal professionals is here to guide you through your legal journey
          with expertise and empathy.
        </p>
        <p className="description-a">
          Founded on principles of integrity, diligence, and client-centricity,
          Lawyer Firm prides itself on delivering tailored legal solutions that
          prioritize your unique circumstances.
        </p>
        <Link to="/contactus">
          <button className="contact-button-a">CONTACT US</button>
        </Link>
      </div>
      <div className="about-right-a">
        <img src="/about-big.webp" alt="Courthouse" className="main-image-a" />
        <img src="/team.webp" alt="Books" className="small-image-a" />
      </div>
    </section>
  );
};

export default About;
